export class ValidationSchema {
  constructor({
    id = Number.NaN,
    name = "",
    description = "",
    courses = [],
  } = {}) {
    this.id = Number.parseInt(id);
    this.name = name;
    this.description = description;
    this.courses = courses;
  }
}
